import { render, staticRenderFns } from "./BatchorderDetail.vue?vue&type=template&id=cbc1f182&scoped=true"
import script from "./BatchorderDetail.vue?vue&type=script&lang=js"
export * from "./BatchorderDetail.vue?vue&type=script&lang=js"
import style0 from "./BatchorderDetail.vue?vue&type=style&index=0&id=cbc1f182&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc1f182",
  null
  
)

export default component.exports